import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7357dd4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recruit-info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "期待您的加入", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, " 如果您充满激情，渴望成功，欢迎您加入新仪征团队，请将简历发送hr@runzehaoyu.com，我们将与您取得联系！ ", -1))
const _hoisted_4 = { class: "info" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"item top\" data-v-7357dd4f><div class=\"content\" data-v-7357dd4f><div class=\"position\" data-v-7357dd4f>职位</div><div class=\"department\" data-v-7357dd4f>招聘部门</div><div class=\"time\" data-v-7357dd4f>发布时间</div><div class=\"arrow\" data-v-7357dd4f>查看详情</div></div></div>", 1)
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "position" }
const _hoisted_8 = { class: "department" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.list, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["item", item.openStatus ? 'active' : '']),
          key: item.id
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.jobTitle), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.jobDept), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.createTime), 1),
            _createElementVNode("div", {
              class: "arrow",
              onClick: ($event: any) => (_ctx.switchStatus(item))
            }, "查看职位", 8, _hoisted_10)
          ])
        ], 2))
      }), 128))
    ])
  ]))
}